import React, {useCallback, useContext, useEffect, useMemo, useRef, useState} from "react";
import {Card, Col, Collapse, Container, Row} from "react-bootstrap";
import {AgGridReact} from "ag-grid-react";
import useWindowDimensions from "hooks/Dimensions";
import template from "../template/TDPS_PORTAL_WireTemplateUpload.xlsx";
import * as URL from "service/UrlConstant";
import {
    WIRE_TEMPLATE_BATCH_UPLOAD_URL
} from "service/UrlConstant";
import {SecurityContext} from "context/security";
import {ToastContext} from "context/Toast";
import CheckboxRenderer from "components/CheckboxRenderer";
import ResponseToast from "components/ResponseToast";
import {
    ACCOUNTS_OPTIONS_NO_SWAP,
    DEFAULT_GRID_PAGINATION_SIZE,
    ENABLE_SCROLL_BUTTONS_PAGINATION_SIZE,
    GRID_COLUMN_PROPERTY
} from "utils/Constants";
import WireTemplateUploadValidationInfo from "./WireTemplateUploadValidationInfo";
import {API_CALL_ERR_MSG} from "../../../utils/ConstantsMsg";
import {UtilsContext} from "../../../context/utils";
import ScrollButton from "../../../components/AgGridToolbar/ToolBarButtons/ScrollButton";
import {addPropertiesToGridColumns, getDisplayedNumberOfGridRows} from "../../../utils/gridColumnUtils";
import {EntityAccountsContext} from "../../../components/entity-accounts/context";
import {getSessionAttribute} from "../../../utils/SessionUtils";
import ActionsRenderer from "../../../components/ActionsRenderer";
import {ActionPanelContext} from "../../../context/action";
import ActionPanelLayout from "../../../layouts/ActionPanelLayout";
import {createExcelExportParams} from "../../../utils/ExcelExportUtils";
import AgGridToolbar from "../../../components/AgGridToolbar/AgGridToolbar";
import DateCellEditor from "../../../utils/DateCellEditor";
import {WIRE_TEMPLATE} from "../../../routes/Routes";
import {WireTemplatesContext} from "./context";
import {useHistory} from "react-router-dom";

export default function WireTemplateUpload() {
    const {showButton, setShowButton} = useContext(UtilsContext);
    const {
        populateDefaultEntity, setInitEntityAccountsOptions
    } = useContext(EntityAccountsContext);
    const {wireTemplatePanelFilterState,wireTemplateResultsDisplayState,
        setWireTemplateResultsDisplayState,
         displayWireTemplatePanelPage,
        TEMPLATE_PANEL_SEARCH_PAGE} = useContext(WireTemplatesContext)
    const {makeGetRequestNoParams} = useContext(SecurityContext);
    const {setDefaultStatus} = useContext(ActionPanelContext)
    const {setHandleExportFunction} = useContext(ActionPanelContext);
    const {success, alert, error} = useContext(ToastContext);
    const {makePostRequest} = useContext(SecurityContext);
    const inputFile = useRef(null);
    const [upload, setUpload] = useState(false);
    const [cancel, setCancel] = useState(false);
    const [validData, setValidData] = useState(true);
    const [errorCount, setErrorCount] = useState(0);
    const [countries, setCountries] = useState([]);
    const [showValidationInfo, setShowValidationInfo] = useState(false);
    const downloadFile = useRef(null);
    const [gridApi, setGridApi] = useState(null);
    const [rowData, setRowData] = useState([]);
    const {isMobile} = useWindowDimensions();
    const {resetFlagRight} = useContext(SecurityContext);
    const myGrid = useRef();
    const [uploadedFile, setUploadedFile] = useState(null);
    const [initialized, setInitialized] = useState(false);
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [showExport, setShowExport] = useState(false);
    const [show, setShow] = useState(false);
    const [actionForAccount, setActionForAccount] = useState('');
    const [showColumnsModal, setShowColumnsModal] = useState(false);
    const [showExportModal, setShowExportModal] = useState(false);
    const [displayedColumnCount, setDisplayedColumnCount] = useState(0);
    const [currentColumnDefs, setCurrentColumnDefs] = useState([]);
    const [showGridToolbar, setShowGridToolbar] = useState(false);
    const [columnState, setColumnState] = useState([]);
    const [paginationPageSize, setPaginationPageSize] = useState(DEFAULT_GRID_PAGINATION_SIZE);
    const hiddenExportGridApi = useRef();
    let history = useHistory();

    useEffect(() => {
        setHandleExportFunction({handleExport: exportQueryList, gridApi: gridApi});
        updateDisplayedColumnCount();
    }, [rowData, gridApi, currentColumnDefs]);

    useEffect(() => {
        getSessionAttribute(ACCOUNTS_OPTIONS_NO_SWAP) ?? setInitEntityAccountsOptions(true);        // set session attribute ACCOUNTS_OPTIONS to the list of all entities and their accounts fetched from the api server at login time
    }, []);



    useEffect(() => {
        populateDefaultEntity(true, true)
    }, [])

    useEffect(() => {
        const onSuccessResponse = (res) => {
            setCountries(res.data || []);
        }
        const onErrorResponse = (err) => {
            console.error("Error fetching country code/country name list", err);
        }
        makeGetRequestNoParams(URL.COUNTRY_LIST_COUNTRY_NAME, onSuccessResponse, onErrorResponse);
    }, [])

    useEffect(() => {
        if (resetFlagRight.current) {
            window.scrollTo(0, 0);
            resetFlagRight.current = false;
            setUpload(false);
        }
    }, [resetFlagRight.current])


    const cellStyleChecker = (param) => {

        if (Array.isArray(param) && param.length > 0) {
            return {backgroundColor: '#F7E8E9', color:'#AE1100'};
        }
        if (typeof param === 'string' && param.length > 0) {
            return {backgroundColor: '#F7E8E9', color:'#AE1100'};
        }

        return {};
    }

    const cellStyleCheckerIsValid = (param) => {
        if (param === false ) {
            return {backgroundColor: '#ce7c7c', color: '#6e0c01'};
        }
        return {};
    }
    const formatErrorMessageForUploadResponse = (errorValue) => {
        if (Array.isArray(errorValue)) {
            return errorValue.join(', ');
        }
        return errorValue;
    }

    const validationCellStyle = params => {
        if (params.value === false) {
            return {backgroundColor: '#6e0c01', color: '#eeecec'}; // red for false
        }
        return {};
    };

    const handleExportActionClicked = (field) => {
        setShow(true);
        setShowExport(true);
    }

    const exportQueryList = (type, rowDataToExport) => {
        if (!hiddenExportGridApi.current || !hiddenExportGridApi.current.api) {
            error("Export grid not initialized. Please try again.");
            return;
        }
        const buildErrComments = (row) => {
            const errValues = Object.keys(row || {})
                .filter(key => key.startsWith('errmsg') && row[key])
                .map(key => String(row[key]).trim())
                .filter(value => value.length > 0);
            return errValues.join('; ');
        };
        let dataToExport = rowDataToExport;
        if (dataToExport) {
            const selectedRows = rowData.filter(row => row.wasselected === true);
            const rowsToExport = selectedRows.length > 0 ? selectedRows : rowData;
            dataToExport = rowsToExport.map(row => {
                const errComments = buildErrComments(row);
                if (!errComments) return row;
                const existingComments = row.comments ? String(row.comments).trim() : '';
                const combinedComments = existingComments
                    ? `${existingComments}; ${errComments}`
                    : errComments;
                return {...row, comments: combinedComments};
            });
        }

        let filteredColumnNames = [];
        if (gridColumnApi) {
            const displayedColumns = gridColumnApi.getAllDisplayedColumns();
            filteredColumnNames = displayedColumns
                .filter(col => col.colDef.field !== 'checkbox' && col.colDef.field !== 'View')
                .map(col => col.colDef.field);
        } else {
            const visibleColumnDefs = (currentColumnDefs && currentColumnDefs.length > 0 ? currentColumnDefs : updatedColumnDefs)
                .filter(cols => cols.field !== 'checkbox' && cols.field !== 'View' && !cols.hide);
            filteredColumnNames = visibleColumnDefs.map(col => col.field);
        }
        hiddenExportGridApi.current.api.setColumnDefs(updatedColumnDefs.filter(cols =>
            filteredColumnNames.includes(cols.field)
        ));

        hiddenExportGridApi.current.api.setRowData(dataToExport);

        const selectedCount = rowData.filter(row => row.wasselected === true).length;
        if (selectedCount > 0) {
            success(`Exporting ${dataToExport.length} selected row(s) with ${filteredColumnNames.length} column(s)...`);
        } else {
            success(`Exporting all ${dataToExport.length} row(s) with ${filteredColumnNames.length} column(s)...`);
        }

        // Export as csv/excel
        if (type === 'EXCEL') {
            hiddenExportGridApi.current.api.exportDataAsExcel(
                createExcelExportParams('WireTemplateUpload', filteredColumnNames)
            );
        } else {
            hiddenExportGridApi.current.api.exportDataAsCsv({columnKeys: filteredColumnNames});
        }
    }

    const updateDisplayedColumnCount = () => {
        if (gridColumnApi) {
            const displayedColumns = gridColumnApi.getAllDisplayedColumns();
            const visibleColumnCount = displayedColumns.filter(col => col.colDef.field !== 'checkbox').length;
            setDisplayedColumnCount(visibleColumnCount);
        }
    }

    const handleColumnFilterClick = (colDef) => {
        gridApi.setColumnDefs(colDef);
        setShowColumnsModal(false);
        setCurrentColumnDefs(colDef);
        updateDisplayedColumnCount();
    }

    const handleExportClick = () => {
        setShowExportModal(true);
    }

    const hasRowErrors = (data) =>
        !!data && !!data.errors && Object.keys(data.errors).length > 0;

    const validateSelectedNodes = (api) => {
        let isValid = true
        let isSelectedNodeExists = false
        let errorCount = 0
        api.forEachNode((node) => {
            if (node.isSelected() === true) {
                node.data['wasselected'] = true
                isSelectedNodeExists = true
                if (hasRowErrors(node.data)) {
                    isValid = false;
                    errorCount += 1
                }
            } else {
                node.data['wasselected'] = false
            }
        });
        if (isSelectedNodeExists) {
            if (!isValid) {
                setErrorCount(errorCount)
                setShowValidationInfo(true);
            }
            setValidData(isValid);
        } else setValidData(false);
    }

    const nodeSelector = (api) => {
        api.forEachNode((node) => {
            if (node.data.wasselected === undefined || node.data.wasselected === true) node.setSelected(true);
        });
    }
    const onDataRendered = (params) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
        // nodeSelector(params.api);
        if (params.columnApi) {
            params.columnApi.autoSizeAllColumns();
        }
        setShowButton(getDisplayedNumberOfGridRows(params.api) >= ENABLE_SCROLL_BUTTONS_PAGINATION_SIZE);
        setShowGridToolbar(true);  // Show toolbar when data is rendered
    }

    const defaultColDef = {
        sortable: true,
        resizable: true,
        floatingFilter: true,
        filter: true,
        enableCellChangeFlash: true,
        lockPinned: !!isMobile,
    };

    const columnTypes = {
        flexColType: {
            sortable: false,
            resizable: false,
            floatingFilter: false,
            filter: false,
            enableCellChangeFlash: false,
            suppressMenu: true,
            flex: 1,
            suppressMovable: true,
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    async function downloadAccountTemplateExcel() {
        const link = document.createElement('a');
        link.href = template;
        link.download = template.split('/').pop();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const columnDefs = useMemo(() => [
        {
            headerName: '',
            headerCheckboxSelection: true,
            field: "checkbox",
            minWidth: 120,
            checkboxSelection: true,
            showDisabledCheckboxes: true,
            pinned: 'left'
        },
        {
            headerName: 'id', field: 'id', hide: true, suppressColumnsToolPanel: true
        },
        {
            headerName: 'Status',
            field: 'uiStatus',
            tooltipValueGetter: params => params.data?.uiStatus,
            cellStyle: params => cellStyleChecker(params.data.isValid),
            pinned: 'left'
        },
        {headerName: 'status', field: 'status', hide: true, suppressColumnsToolPanel: true},
       {
            headerName: 'Account',
            field: 'accountCode',
            tooltipValueGetter: params => params.data && formatErrorMessageForUploadResponse(params.data.errors?.accountCode),
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.accountCode),
        }, {
            headerName: 'Template Name',
            field: 'templateName',
            filter: true,
            tooltipValueGetter: params => params.data && formatErrorMessageForUploadResponse(params.data.errors?.templateName),
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.templateName)
        },
        {
            headerName: 'Settlement Currency',
            field: 'settlementCurrency',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.settlementCurrency,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.settlementCurrency)
        },
        {
            headerName: 'Debtor Name',
            field: 'debtorName',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.debtorName,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.debtorName)
        },
        {
            headerName: 'Debtor Street Name',
            field: 'debtorStreetName',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.debtorStreetName,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.debtorStreetName)
        },
        {
            headerName: 'Debtor Post Code',
            field: 'debtorPostCode',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.debtorPostCode,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.debtorPostCode)
        },
        {
            headerName: 'Debtor Town Name',
            field: 'debtorTownName',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.debtorTownName,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.debtorTownName)
        },
        {
            headerName: 'Debtor Province',
            field: 'debtorProvince',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.debtorProvince,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.debtorProvince)
        },
        {
            headerName: 'Debtor Country',
            field: 'debtorCountry',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.debtorCountry,
            editable: true,
            cellEditor: 'agRichSelectCellEditor',
            cellEditorParams: {
                values: ['', ...countries.map(country => country.countryCode)],
                formatValue: value => {
                    if (!value) return '';
                    const match = countries.find(country => country.countryCode === value);
                    return match ? match.country : value;
                }
            },
            valueFormatter: params => {
                if (!params.value) return '';
                const match = countries.find(country => country.countryCode === params.value);
                return match ? match.country : params.value;
            },
            cellStyle: (params) => cellStyleChecker(params.data.errors?.debtorCountry)
        },
        {
            headerName: 'Creditor BIC',
            field: 'creditorBIC',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.creditorBIC,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.creditorBIC)
        },
        {
            headerName: 'Creditor Account/IBAN',
            field: 'creditorAccountIBAN',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.creditorAccountIBAN,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.creditorAccountIBAN)
        },
        {
            headerName: 'Creditor Name',
            field: 'creditorName',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.creditorName,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.creditorName)
        },
        {
            headerName: 'Creditor Street Name',
            field: 'creditorStreetName',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.creditorStreetName,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.creditorStreetName)
        },
        {
            headerName: 'Creditor Post Code',
            field: 'creditorPostCode',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.creditorPostCode,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.creditorPostCode)
        },
        {
            headerName: 'Creditor Town Name',
            field: 'creditorTownName',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.creditorTownName,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.creditorTownName)
        },
        {
            headerName: 'Creditor Province',
            field: 'creditorProvince',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.creditorProvince,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.creditorProvince)
        },
        {
            headerName: 'Creditor Country',
            field: 'creditorCountry',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.creditorCountry,
            editable: true,
            cellEditor: 'agRichSelectCellEditor',
            cellEditorParams: {
                values: ['', ...countries.map(country => country.countryCode)],
                formatValue: value => {
                    if (!value) return '';
                    const match = countries.find(country => country.countryCode === value);
                    return match ? match.country : value;
                }
            },
            valueFormatter: params => {
                if (!params.value) return '';
                const match = countries.find(country => country.countryCode === params.value);
                return match ? match.country : params.value;
            },
            cellStyle: (params) => cellStyleChecker(params.data.errors?.creditorCountry)
        },
        {
            headerName: 'Creditor Agent BIC',
            field: 'creditorAgentBIC',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.creditorAgentBIC,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.creditorAgentBIC)
        },
        {
            headerName: 'Creditor Agent Clearing System Code',
            field: 'creditorAgentClearingSystemCode',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.creditorAgentClearingSystemCode,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.creditorAgentClearingSystemCode)
        },
        {
            headerName: 'Creditor Agent Clearing System ID',
            field: 'creditorAgentClearingSystemID',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.creditorAgentClearingSystemID,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.creditorAgentClearingSystemID)
        },
        {
            headerName: 'Creditor Agent Account/IBAN',
            field: 'creditorAgentAccountIBAN',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.creditorAgentAccountIBAN,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.creditorAgentAccountIBAN)
        },
        {
            headerName: 'Creditor Agent Name',
            field: 'creditorAgentName',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.creditorAgentName,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.creditorAgentName)
        },
        {
            headerName: 'Creditor Agent Street Name',
            field: 'creditorAgentStreetName',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.creditorAgentStreetName,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.creditorAgentStreetName)
        },
        {
            headerName: 'Creditor Agent Post Code',
            field: 'creditorAgentPostCode',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.creditorAgentPostCode,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.creditorAgentPostCode)
        },
        {
            headerName: 'Creditor Agent Town Name',
            field: 'creditorAgentTownName',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.creditorAgentTownName,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.creditorAgentTownName)
        },
        {
            headerName: 'Creditor Agent Province',
            field: 'creditorAgentProvince',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.creditorAgentProvince,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.creditorAgentProvince)
        },
        {
            headerName: 'Creditor Agent Country',
            field: 'creditorAgentCountry',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.creditorAgentCountry,
            editable: true,
            cellEditor: 'agRichSelectCellEditor',
            cellEditorParams: {
                values: ['', ...countries.map(country => country.countryCode)],
                formatValue: value => {
                    if (!value) return '';
                    const match = countries.find(country => country.countryCode === value);
                    return match ? match.country : value;
                }
            },
            valueFormatter: params => {
                if (!params.value) return '';
                const match = countries.find(country => country.countryCode === params.value);
                return match ? match.country : params.value;
            },
            cellStyle: (params) => cellStyleChecker(params.data.errors?.creditorAgentCountry)
        },
        {
            headerName: 'Intermediary Agent BIC',
            field: 'intermediaryAgentBIC',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.intermediaryAgentBIC,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.intermediaryAgentBIC)
        },
        {
            headerName: 'Intermediary Agent Clearing System Code',
            field: 'intermediaryAgentClearingSystemCode',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.intermediaryAgentClearingSystemCode,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.intermediaryAgentClearingSystemCode)
        },
        {
            headerName: 'Intermediary Agent Clearing System ID',
            field: 'intermediaryAgentClearingSystemID',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.intermediaryAgentClearingSystemID,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.intermediaryAgentClearingSystemID)
        },
        {
            headerName: 'Intermediary Agent Account/IBAN',
            field: 'intermediaryAgentAccountIBAN',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.intermediaryAgentAccountIBAN,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.intermediaryAgentAccountIBAN)
        },
        {
            headerName: 'Intermediary Agent Name',
            field: 'intermediaryAgentName',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.intermediaryAgentName,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.intermediaryAgentName)
        },
        {
            headerName: 'Intermediary Agent Street Name',
            field: 'intermediaryAgentStreetName',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.intermediaryAgentStreetName,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.intermediaryAgentStreetName)
        },
        {
            headerName: 'Intermediary Agent Post Code',
            field: 'intermediaryAgentPostCode',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.intermediaryAgentPostCode,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.intermediaryAgentPostCode)
        },
        {
            headerName: 'Intermediary Agent Town Name',
            field: 'intermediaryAgentTownName',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.intermediaryAgentTownName,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.intermediaryAgentTownName)
        },
        {
            headerName: 'Intermediary Agent Province',
            field: 'intermediaryAgentProvince',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.intermediaryAgentProvince,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.intermediaryAgentProvince)
        },
        {
            headerName: 'Intermediary Agent Country',
            field: 'intermediaryAgentCountry',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.intermediaryAgentCountry,
            editable: true,
            cellEditor: 'agRichSelectCellEditor',
            cellEditorParams: {
                values: ['', ...countries.map(country => country.countryCode)],
                formatValue: value => {
                    if (!value) return '';
                    const match = countries.find(country => country.countryCode === value);
                    return match ? match.country : value;
                }
            },
            valueFormatter: params => {
                if (!params.value) return '';
                const match = countries.find(country => country.countryCode === params.value);
                return match ? match.country : params.value;
            },
            cellStyle: (params) => cellStyleChecker(params.data.errors?.intermediaryAgentCountry)
        },
        {
            headerName: 'Remittance Information',
            field: 'remittanceInformation',
            filter: true,
            tooltipValueGetter: params => params.data && params.data.errors?.remittanceInformation,
            editable: true,
            cellStyle: (params) => cellStyleChecker(params.data.errors?.remittanceInformation)
        }
    ], [countries]);

    const updatedColumnDefs = useMemo(() => addPropertiesToGridColumns(columnDefs, GRID_COLUMN_PROPERTY), [columnDefs]);


    const onGridReady = (params) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
        setCurrentColumnDefs(updatedColumnDefs);
        updateDisplayedColumnCount();
    }

    const handleDownloadTemplate = () => {
        downloadFile.current.click()
    }

    const uploadComponent = function () {
        return (<Card id="uploadCard" onClick={handleUploadCardClick}
                      className="td-bg-colour-7 p-5 d-flex flex-column justify-content-center" align="center"
                      style={{height: '350px', cursor: 'pointer'}}>
            <Card.Title><h1>Upload</h1></Card.Title>
            <Card.Text>
                Upload the wire template file.
            </Card.Text>
            <i className="td-icon-colour-primary td-icon icon-large td-icon-downloadCertificate icon-rotate"></i>
        </Card>);
    }


    const handleUploadCardClick = () => {
        inputFile.current.click()
    }

    const handleUploadFile = (event) => {
        const file = event.target.files[0];
        setUploadedFile(file);
        const formData = new FormData();
        formData.append('file', event.target.files[0]);
        document.getElementById('file').value = null;
        setRowData([]);

        const onSuccessResponse = (response) => {
            const data = response.data || [];
            const hasError = data.some(row => row.isValid === false);
            if (hasError) {
                error("Some records have errors. Please review the details.");
            } else {
                success("Wire templates Processed successfully");
            }

            setRowData(data);
            setUpload(true);
            setCancel(false);
        }


        const onErrorResponse = (err) => {
            console.error("Error on file upload", err);
            let errMsg = API_CALL_ERR_MSG;
            if (err.response && err.response.data) {
                let data = err.response.data;
                if (typeof data === 'string') {
                    try {
                        data = JSON.parse(data);
                    } catch {
                        // will keep as string if not JSON
                    }
                }
                if (typeof data === 'object' && data.message) {
                    const match = data.message.match(/ERROR:(.*)/);
                    errMsg = match ? match[1].trim() : data.message;
                } else if (typeof data === 'string') {
                    errMsg = data;
                }
            }
            error(errMsg);
            setCancel(true);
        }

        makePostRequest(formData, URL.WIRE_TEMPLATE_UPLOAD_VALIDATE_URL, onSuccessResponse, onErrorResponse);

    }

    const onRowSelected = (params) => {
        validateSelectedNodes(params.api)
    }

    const onPaginationChange = (params) => {
        setShowButton(getDisplayedNumberOfGridRows(gridApi) >= ENABLE_SCROLL_BUTTONS_PAGINATION_SIZE);
    }

    const isRowSelectable = (params) => {
        return true;
    };

    const getRowStyle = (params) => {
        return {}
    }
    const onCellEditingStopped = useCallback((e) => {
        const status = ['PENDING APPROVAL - 1', 'PENDING BROKER ACCOUNT', 'ERROR'];
        // Only disable selection if status is NOT in allowed list and value is empty/null
        if (!(e.data.status && status.includes(e.data.status)) && (e.value === null || e.value === "")) {
            e.api.getRowNode(e.node.rowIndex).selectable = false;
            e.api.getRowNode(e.node.rowIndex).setSelected(false);
            e.api.getRowNode(e.node.rowIndex).setDataValue(e.colDef.field, "");
            return;
        }
        // Otherwise, do nothing and allow selection
    }, []);

    const handleProcessFile = (event) => {
        if (!gridApi) return;

        const selectedData = gridApi.getSelectedRows();

        if (selectedData.length < 1) {
            alert("No valid records are selected. Please review the file and reupload it")
            return
        }

        const data = [];
        selectedData.forEach(e => {
            let locateObj = {};
            columnDefs.forEach(col => {
                if (col.field) {
                    locateObj[col.field] = e[col.field];
                }
            });
            data.push(locateObj);
        });

        const onSuccessResponse = (response) => {
            success("Process Wire Templates Processed successfully");
            let wireTemplateDisplayState = JSON.parse(JSON.stringify(wireTemplateResultsDisplayState))
            setDefaultStatus(wireTemplatePanelFilterState.status?wireTemplatePanelFilterState.status:'ALL')
            if (!response.data || response.data.length === 0) {
                wireTemplateDisplayState.resData = []
                setWireTemplateResultsDisplayState(wireTemplateDisplayState);
                alert('No Wire Templates found matching your search');
            } else {
                wireTemplateDisplayState.resData = ([...response.data])
                setWireTemplateResultsDisplayState(wireTemplateDisplayState);
            }
            displayWireTemplatePanelPage(TEMPLATE_PANEL_SEARCH_PAGE);
            // navigate to page Wire Template Search Page
            history.push(WIRE_TEMPLATE);
        };

        const onErrorResponse = (err) => {
            error("Error in processing");
            if (gridApi) {
                gridApi.deselectAll();
            }
        }

        makePostRequest(data,
            WIRE_TEMPLATE_BATCH_UPLOAD_URL, onSuccessResponse, onErrorResponse);
    }

    return (<>
        <Container fluid>
            <Row className="py-4">
                <Col xs={12} className="pl-4">
                    <h1>Wire Template Upload</h1>
                </Col>
            </Row>
            <Collapse in={!upload} timeout={0}>
                <Row className="align-items-stretch">
                    <Col xs={12} sm={12} md={12} lg={6} className="px-4 pb-3 pt-0 h-100">
                        <Row md={'12'} sm={'12'} className="mb-4">
                        </Row>
                        <input type='file' id='file'
                               accept=".xlsx,.csv,.xls"
                               ref={inputFile} onChange={(e) => handleUploadFile(e)} style={{display: 'none'}}/>
                        {uploadComponent()}
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={6} className="px-4 pb-3 pt-0 h-100">
                        <Row md={'12'} sm={'12'} className="mb-4">
                        </Row>
                        <Card className="td-bg-colour-7 p-5 d-flex flex-column justify-content-center"
                              align="center" onClick={downloadAccountTemplateExcel}
                              style={{height: '350px', cursor: 'pointer'}}>
                            <Card.Title><h1>Download Template</h1></Card.Title>
                            <Card.Text>
                                Click to download the Account Template.
                            </Card.Text>
                            <i className="td-icon-colour-primary td-icon icon-large td-icon-downloadCertificate"></i>
                        </Card>
                    </Col>
                </Row>

            </Collapse>
            <Collapse in={upload} timeout={0}>
                <Row>
                    <Col xs={12}>
                        <AgGridToolbar
                            title="Wire Template Upload"
                            wireTemplateUploadScreen={true}
                            gridApi={gridApi}
                            gridColumnApi={gridColumnApi}
                            columnDefs={currentColumnDefs}
                            setColumnDefs={setCurrentColumnDefs}
                            onColumnFilterClick={handleColumnFilterClick}
                            showButton={showButton}
                            setShowButton={setShowButton}
                            columnState={columnState}
                            paginationPageSize={paginationPageSize}
                            setPaginationPageSize={setPaginationPageSize}
                        />
                        <div
                            id="myGrid"
                            ref={myGrid}
                            className="ag-theme-alpine ag-grid-block">
                            <AgGridReact
                                ref={myGrid}
                                frameworkComponents={{
                                    checkboxRenderer: CheckboxRenderer,
                                    actionsRenderer: ActionsRenderer,
                                    dateCellEditor: DateCellEditor
                                }}
                                paginationPageSize={DEFAULT_GRID_PAGINATION_SIZE}
                                groupDefaultExpanded={'1'}
                                enableRowGroup={false}
                                suppressRowClickSelection={true}
                                suppressDragLeaveHidesColumns={true}
                                suppressMakeColumnVisibleAfterUnGroup={true}
                                suppressModelUpdateAfterUpdateTransaction={true}
                                suppressScrollOnNewData={true}
                                suppressAggFuncInHeader={true}
                                allowShowChangeAfterFilter={false}
                                rowGroupPanelShow={'never'}
                                enableSorting={true}
                                enableFilter={true}
                                pagination={true}
                                onGridReady={onGridReady}
                                defaultColDef={defaultColDef}
                                columnTypes={columnTypes}
                                columnDefs={updatedColumnDefs}
                                getRowStyle={getRowStyle}
                                rowData={rowData}
                                animateRows={true}
                                tooltipShowDelay={0}
                                rowSelection={'multiple'}
                                onFirstDataRendered={onDataRendered}
                                onRowDataChanged={onDataRendered}
                                onRowSelected={onRowSelected}
                                isRowSelectable={isRowSelectable}
                                showDisabledCheckboxes={true}
                                onCellEditingStopped={onCellEditingStopped}
                                onPaginationChanged={onPaginationChange}
                                rowHeight={28}
                            >
                            </AgGridReact>
                        </div>
                    </Col>
                </Row>
            </Collapse>
            <Collapse in={upload} timeout={0}>
                <Row className="pt-3">
                    <Col lg={8} className="d-none d-lg-block"></Col>
                    <Col sm={6} md={4} lg={2} className="pt-4 pt-sm-2 mb-xs-2">
                        <button className="btn btn-block td-btn-secondary-clear" href="#"
                                onClick={() => {
                                    setUpload(false);
                                }}>Cancel
                        </button>
                    </Col>
                    <Col sm={6} md={4} lg={2} className="pt-4 pt-sm-2 mb-xs-2">
                        <button className="btn btn-block td-btn-primary-light" href="#"
                                onClick={handleProcessFile}>Process Wire Templates
                        </button>
                    </Col>
                </Row>
            </Collapse>
            <Collapse in={show} timeout={0}>
                <Row>
                    <Col xs={12}>
                        <div className="p-4 td-bg-colour-7">
                            <h2>Wire Template Process</h2>
                            <p>Review and confirm the wire template details before processing.</p>
                        </div>
                    </Col>
                </Row>
            </Collapse>
            <WireTemplateUploadValidationInfo show={showValidationInfo} errorCount={errorCount}
                                              onHide={() => setShowValidationInfo(false)}></WireTemplateUploadValidationInfo>
        </Container>
        {showButton && <ScrollButton showButton={showButton}/>}
        <ActionPanelLayout actionForAccount={actionForAccount} show={show} setShow={setShow}
                           showExport={showExport} setShowExport={setShowExport}
                           gridApi={gridApi}
        />
        <ResponseToast isFullWidth={true}/>
        <div style={{display: 'none'}}>
            <div id="hiddenExportGrid" className="ag-theme-alpine" style={{width: '100%', height: '100%'}}>
                <AgGridReact ref={hiddenExportGridApi}/>
            </div>
        </div>
    </>);
}

